import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Message, MessageService } from 'primeng/api';
import { FormValidation } from 'src/app/libs/ruvpp-angular2-comun/FormValidation';
import { HttpSession } from 'src/app/libs/ruvpp-angular2-comun/HttpSession';
import { MenuComponent } from '../menu/menu.component';
import { SimuladorService } from './../../datos/simulador.service';
import { JsonResponse } from './../../libs/ruvpp-angular2-comun/modelo/Index';
import { ServicioAlertas } from './../../libs/ruvpp-angular2-comun/ServicioAlertas';
import { DatosElementoDTO, ElementoDTO, EspacioDTO, EspacioForm, InputObtenerCostoManoObra, InputObtenerCostoPrecioUnitarioMateriales, InputObtenerCostoTotalManoObraXElemento, InputObtenerCostoTotalMaterialesXElemento, InputObtenerEspacioDetalle, InputObtenerEspacio_Pages, InputObtenerPrototipo_Pages, InputObtenerReporte, OutputObtenerCostoManoObra, OutputObtenerCostoPrecioUnitarioMateriales, OutputObtenerCostoTotalManoObraXElemento, OutputObtenerCostoTotalMaterialesXElemento, OutputObtenerElementos, OutputObtenerEspacioDetalle, OutputObtenerEspacio_Pages, OutputObtenerPrototipoDetalle, OutputObtenerPrototipo_Pages, PersonalDTO, PrototipoDTO, PrototipoForm, SelectItemGroups, TipoEspacioDTO, TipoPrototipoDTO, UnidadMedidaDTO, InputObtenerCostoExcelExplosionTotalMateriales, OutputObtenerCostoExcelExplosionTotalMateriales, InputObtenerCostoExcelExplosionXConcepto, OutputObtenerCostoExcelExplosionXConcepto, InputObtenerCostoExcelTotalManoObra, OutputObtenerCostoExcelTotalManoObra, InputObtenerCostoTotalExcelPresupuestoPrototipo, OutputObtenerCostoTotalExcelPresupuestoPrototipo, InputObtenerCostoTotalExcelPrototipo, OutputObtenerCostoTotalExcelPrototipo, AmpliacionDTO, InputObtenerAmpliacionxConceptoIntegrado, OutputObtenerAmpliacionxConceptoIntegrado, AmpliacionxConceptoIntegradoDTO, ConceptoIntegradoDTO, ItemGroupsAmpliacion, $AmpliacionxConceptoIntegrado, InputObtenerCostoTotalExcelAmpliacion, OutputObtenerCostoTotalExcelAmpliacion, CostoTotalExcelAmpliacionDTO, $AmpliacionxConceptoIntegradoDTO, InputObtenerCostoExcelTotalManoObraAmpliacion, OutputObtenerCostoExcelTotalManoObraAmpliacion, InputObtenerCostoExcelTotalMaterialesAmpliacion, OutputObtenerCostoExcelTotalMaterialesAmpliacion, CostoExcelTotalManoObraAmpliacionDTO, CostoExcelTotalMaterialesAmpliacionDTO, OutputObtenerCostoTotalExcelPresupuestoElemento, InputObtenerCostoTotalExcelPresupuestoElemento, CostoTotalExcelPresupuestoElementoDTO, CostoTotalExcelPresupuestoPrototipoDTO, InputObtenerCostoTotalExcelPresupuestoAmpliacion, OutputObtenerCostoTotalExcelPresupuestoAmpliacion, CostoTotalExcelPresupuestoAmpliacionDTO, OutputObtenerDocuemntosXPrototipo, DocuemntosXPrototipoDTO, InputObtenerAmpliacionModelo, OutputObtenerAmpliacionModelo, AmpliacionModeloDTO, OutputObtenerDocumentosXAmpliacion, InputObtenerDocumentosXAmpliacion, DocumentosXAmpliacionDTO } from './../../modelo';


@Component({
    selector: 'app-simulador',
    templateUrl: './simulador.component.html',
    //styleUrls: ['../../../assets/css/styles.css', '../../../assets/css/bootstrap.css']
})

export class SimuladorComponent implements OnInit {

    //Otros

    public activeTab: string = "pestana1";
    public activeMenu: string = "elemento01";
    public activeMenuEspacio: string = "elemento01";
    public grupoElementos: SelectItemGroups<OutputObtenerElementos, ElementoDTO>[];
    public datosElemento: DatosElementoDTO;
    public idElementSelect: number[];
    public checked: SelectItemGroups<OutputObtenerElementos, ElementoDTO>[] = [];
    public checkedGrup: SelectItemGroups<any, any>[] = [];
    public checkedEspacio: SelectItemGroups<EspacioDTO, any>[] = [];
    public checkedGrupEspacio: SelectItemGroups<any, any>[] = [];
    public grupoEspacios: SelectItemGroups<TipoEspacioDTO, any>[];
    public grupoPrototipos: SelectItemGroups<TipoPrototipoDTO, any>[];
    public entity: SelectItemGroups<OutputObtenerElementos, ElementoDTO>;
    public listUnidadMedida: UnidadMedidaDTO[];
    public listPersonal: PersonalDTO[];
    public forward: string;
    public ModalidadObra: string = 'ConstruYO Reparaciones Menores';
    public idModalidadObra: number = 1;
    public isAutoproduccion: boolean = false;
    public CostoTotalProyecto: number = 0;
    public ConAsistenciaTecnica: number = 0;
    public ConConstructora: number = 0;


   // public TotalManoObraAmpliacion: number = 0;
    public TotalMaterialesAmpliacion: number = 0;
    public TotalPresupuestoAmpliacion: number = 0;
    public SubTotalAmpliacion: number = 0;
    public IndirectoAmpliacion: number = 0;
   
    public tipoVivienda: string = '0';
    public tipoAsistencia: string = '0';
    public clave: string = '';
    public modalPresupuesto: boolean = false;
    public modalManoObra: boolean = false;
    public modalMateriales: boolean = false;
    public modalPresupuestoAmpliacion: boolean = false;
    public titulo: string;
    public SubTotal: number = 0;
    public Indirecto: number = 0;
    public $Total: number = 0;


    public TotalManosObraElemento: number = 0;
    public SubTotalManosObraElemento: number = 0;
    public IndirectoManosObraElemento: number = 0;

    public TotalMaterialesElemento: number = 0;


    public SubTotalManosObraAmpliacion: number = 0;
    public IndirectoManosObraAmpliacion: number = 0;
    public TotalManosObraAmpliacion: number = 0;


    public groupsAmpliacion: ItemGroupsAmpliacion<object>[];
    public listSubMenuAmpliacion: AmpliacionModeloDTO[] = [];
    public ampliacion: AmpliacionDTO;
    public listConceptoIntegradoObligatorios: ConceptoIntegradoDTO[];
    public costoTotalConceptoIntegradoObligatorios: number;
    public groupAmpliacionxConceptoIntegrado: $AmpliacionxConceptoIntegrado[] = [];
    public costoTotalExcelAmpliacion: CostoTotalExcelAmpliacionDTO[];
    public checkedAll: boolean = false;
    public tipoPlanta: string = '1';
    public largo: number | null;
    public ancho: number | null;
    public m2: number | null;
    public costoTotalAmpliacion: number = 0;
    public groupCostoTotalExcelPresupuestoElemento: CostoTotalExcelPresupuestoElementoDTO[] = [];
    public listaDocumentos: DocuemntosXPrototipoDTO;
    public listDocument: DocumentosXAmpliacionDTO[] = [];
    public tituloModal: string;
    public listAmpliacionModelo: AmpliacionModeloDTO[];
    public listDocumentosXAmpliacion: DocumentosXAmpliacionDTO[];

    //Simulador

    public simuladorForm: EspacioForm;

    //Espacio
    public espacio: EspacioDTO;
    public espacioForm: EspacioForm;

    //Prototipo

    @ViewChild('fileUpload') fileUpload: any;
    public prototipo: PrototipoDTO;
    public prototipoForm: PrototipoForm;
    public uploadedFiles: any[] = [];
    public msgs: Message[] = [];


    //Lista de Consultas 

    public costoManoObra: OutputObtenerCostoManoObra[];
    public precioUnitarioMateriales: OutputObtenerCostoPrecioUnitarioMateriales[];
    public costoTotalManoObraXElemento: OutputObtenerCostoTotalManoObraXElemento[];
    public costoTotalMaterialesXElemento: OutputObtenerCostoTotalMaterialesXElemento[];
    public costoExcelTotalManoObraAmpliacion: CostoExcelTotalManoObraAmpliacionDTO[];
    public costoExcelTotalMaterialesAmpliacion: CostoExcelTotalMaterialesAmpliacionDTO[];
    public costoTotalExcelPresupuestoElemento: OutputObtenerCostoTotalExcelPresupuestoElemento[];
    public costoTotalExcelPresupuestoAmpliacion: CostoTotalExcelPresupuestoAmpliacionDTO[];


    public modalTotales: boolean = false;

    //Modal
    public aviso: boolean = false;
    public modalDetalleEspacio: boolean = false;
    public descripcionAmplia: string;
    public nombreElemento: string;

    //Menu
    public menu: MenuComponent;
    public urlImage: string;

    public idAmpliacion: number = 1;

    /**
     * 
     * @param messageService
     * @param servicioAlertas
     * @param service
     * @param _router
     */
    constructor(private messageService: MessageService, private servicioAlertas: ServicioAlertas, private service: SimuladorService, private _router: Router) {
        this.menu = new MenuComponent(_router);
    }

    /**
     * 
     */
    ngOnInit(): void {

        this.loading();
        //this.initSimuladorForm();
        this.initEspacioForm();
        //this.initPrototipoForm();

        this.idElementSelect = [];
        this.checked = [];
        this.checkedEspacio = [];

        //this.onChangeTipoVivienda();
        this.setForward();
    }


    /**
     * 
     */
    private setForward(): void {

        this.forward = HttpSession.getAttribute('FORWARD');

        if (this.forward != null) {

            switch (this.forward) {
                case 'ELEMENTOS': this.activeTab = 'pestana1'; break;
                case 'ESPACIOS': this.activeTab = 'pestana22'; break;
                case 'VIVIENDAS': this.activeTab = 'pestana3'; break;
                case 'GUIAS': this.activeTab = 'pestana5'; break;
            }

        }
    }

    /**
     * 
     * @param name
     */
    public changeTab(name: string): void {
        this.activeTab = name;
    }

    /**
     * 
     * @param entity
     */
    public changeMenu(entity: any): void {

        console.warn('entity -->> ', entity)

        for (let row of this.grupoElementos) {
            row.checked = false;
        }

        this.activeMenu = entity.index;

        //debugger

        //let listaSiglas: string[] = [];
        //listaSiglas.push('T');

        //let listas: any[] = [];

        //for (let row of listaSiglas) {
        //    let subQuery:any[] = entity.items.filter(row => row.siglas == row)

        //    if (subQuery != null && subQuery.length > 0) {
        //        listas.push(subQuery);
        //    }

           
        //}

        


        entity.checked = true;

    }

    /**
     * 
     * @param entity
     */
    public changeMenuEspacio(entity: any): void {

        for (let row of this.grupoEspacios) {
            row.checked = false;
        }

        this.activeMenuEspacio = entity.index;

        entity.checked = true;
    }

    /**
     * 
     */
    private async loading() {

        let usuario = HttpSession.getAttribute('USER_NAME');

        let isAdministrador: boolean = false;

        if (usuario != null) {
            isAdministrador = true;
        }

        let datosElementoDTO: JsonResponse<DatosElementoDTO> = null;

        // Obtener Elementos
        {
            datosElementoDTO = await this.service.ObtenerElementos().toPromise();
        }

        //Obtener Espacios
        {
            //debugger

            let data: InputObtenerEspacio_Pages = <InputObtenerEspacio_Pages>{ tamanioPagina: 9000, pagina: 1 };

            let resultado: JsonResponse<OutputObtenerEspacio_Pages> = await this.service.ObtenerEspacioPages(data).toPromise();

            if (resultado != null && resultado.code == 200 && resultado.model != null) {

                this.espacioForm.listEspacios = resultado.model.listEspacios;

                if (isAdministrador != null && isAdministrador == false) {
                    this.espacioForm.listEspacios = this.espacioForm.listEspacios.filter(row => row.activo == true);
                }

            }
        }

        //Obtener Prototipos
        //{
        //    let data: InputObtenerPrototipo_Pages = <InputObtenerPrototipo_Pages>{ tamanioPagina: 9000, pagina: 1 };

        //    let resultado: JsonResponse<OutputObtenerPrototipo_Pages> = await this.service.ObtenerPrototipoPages(data).toPromise();

        //    if (resultado != null && resultado.code == 200 && resultado.model != null) {

        //        this.prototipoForm.listPrototipos = resultado.model.listPrototipo;

        //        if (isAdministrador != null && isAdministrador == false) {
        //            this.prototipoForm.listPrototipos = this.prototipoForm.listPrototipos.filter(row => row.activo == true);
        //        }

        //    }

        //}

        //Obtener Ampliacion Modelo

        {

            let dato: InputObtenerAmpliacionModelo = <InputObtenerAmpliacionModelo>{ idAmpliacion: null }

            let resultado: JsonResponse<OutputObtenerAmpliacionModelo> = await this.service.ObtenerAmpliacionModelo(dato).toPromise();

            if (resultado != null && resultado.code == 200 && resultado.model != null) {
                this.listAmpliacionModelo = resultado.model.listAmpliacionModelo;
            }

            console.warn('ListAmpliacionModelo -->> ', this.listAmpliacionModelo)
        }

        // Obtener Documentos por Ampliacion
        {
            let dato: InputObtenerDocumentosXAmpliacion = <InputObtenerDocumentosXAmpliacion>{ idAmpliacion: null };

            let respuesta: JsonResponse<OutputObtenerDocumentosXAmpliacion> = await this.service.ObtenerDocumentosXAmpliacion(dato).toPromise();

            if (respuesta != null && respuesta.code == 200 && respuesta.model != null) {
                this.listDocumentosXAmpliacion = respuesta.model.listDocumentosXAmpliacion;
            }

            console.warn('ListDocumentosXAmpliacion -->> ', this.listDocumentosXAmpliacion)

        }


        this.ObtenerElementos(datosElementoDTO);

        this.groupsAmpliacion = [];

        if (this.datosElemento != null && this.datosElemento.listAmpliacion != null) {

            let cont = 1;

            for (let row of this.datosElemento.listAmpliacion) {

                let checked: boolean = false;

                if (cont == 1) {
                    checked = true;
                }

                let dato: ItemGroupsAmpliacion<object> = <ItemGroupsAmpliacion<object>>{ entity: row, name: row.nombreTipoEspacio, checked: checked, length: 0 };

                if (cont == 1) {
                    this.setlistSubMenuAmpliacion(dato)
                }

                this.groupsAmpliacion.push(dato);

                cont++;
            }


        }

    }

    /**
     * 
     * @param entity
     */
    public clickMenuAmpliacion(entity: ItemGroupsAmpliacion<object>): void {

        for (let row of this.groupsAmpliacion) {
            row.checked = false;
        }

        entity.checked = true;

        this.setlistSubMenuAmpliacion(entity)

        if (this.listSubMenuAmpliacion != null && this.listSubMenuAmpliacion.length == 0) {
            this.onClickAmpliacion(entity, null);
        }

        this.idAmpliacion = entity.entity.idAmpliacion;
    }



  /**
    * 
    * @param entity
    * @param subMenu
    */  public async clickSubMenuAmpliacion(entity: ItemGroupsAmpliacion<object>, subMenu: any) {

        for (let row of this.listSubMenuAmpliacion) {
            row.checked = false;
        }

        subMenu.checked = true;

        await this.onClickAmpliacion(entity, subMenu);

        await this.TotalCalculos();
    }

    /**
     * 
     * @param entity
     */
    private setlistSubMenuAmpliacion(entity: ItemGroupsAmpliacion<object>): void {

        let idAmpliacion: number = entity.entity.idAmpliacion;

        this.listSubMenuAmpliacion = [];

        if (this.listAmpliacionModelo != null) {

            let filter = this.listAmpliacionModelo.filter(row => row.idAmpliacion == idAmpliacion);

            if (filter != null && filter.length > 0) {

                if (entity.length == 0) {
                    for (let row of filter) {
                        row.checked = false;
                    }
                }

                this.listSubMenuAmpliacion.push(...filter);

            }
        }

    }

    /**
     * Obtener valores acabados ampliación
     */
    private async ObtenerCostoTotalExcelAmpliacion() {

        this.costoTotalExcelAmpliacion = [];

        if (this.ampliacion != null) {

            let dato: InputObtenerCostoTotalExcelAmpliacion = <InputObtenerCostoTotalExcelAmpliacion>{
                idAmpliacion: this.ampliacion.idAmpliacion,
                largo: this.largo,
                ancho: this.ancho,
                idPiso: Number(this.tipoPlanta),
                clave: this.getClave(),
                clavePU: this.getClavePU()
            };

            let respuesta: JsonResponse<OutputObtenerCostoTotalExcelAmpliacion> = await this.service.ObtenerCostoTotalExcelAmpliacion(dato).toPromise();

            if (respuesta != null && respuesta.code == 200 && respuesta.model != null) {
                this.costoTotalExcelAmpliacion = respuesta.model.listCostoTotalExcelAmpliacion;
            }
        }

    }

    /**
     * 
     * @param resultado
     */
    private async ObtenerElementos(resultado: JsonResponse<DatosElementoDTO>) {

        //let resultado: JsonResponse<DatosElementoDTO> = await this.service.ObtenerElementos().toPromise();

        if (resultado != null && resultado.code == 200 && resultado.model != null) {

            this.datosElemento = resultado.model;

            this.grupoElementos = [];

            let cont: number = 1;

            //Agrupar Elementos
            {
                for (let tipoElemento of this.datosElemento.listTipoElementos) {

                    let index: string = '';

                    let filter: OutputObtenerElementos[] = this.datosElemento.listElementos.filter(row => row.idTipoElemento == tipoElemento.idTipoElemento);

                    let items: any[] = [];

                    for (let entity of filter) {

                        let elemento: ElementoDTO = <ElementoDTO>{
                            idElemento: entity.idElemento,
                            nombreElemento: entity.nombreElemento,
                            clave: entity.clave,
                            idTipoDatoEntrada: entity.idTipoDatoEntrada,
                            idTipoElemento: entity.idTipoElemento,
                            unidadMedida: entity.unidadMedida,
                            nombreTipoDatoEntrada: entity.nombreTipoDatoEntrada,
                            nombreTipoElemento: entity.nombreTipoElemento,
                            idManoObra: entity.idManoObra,
                            largo: null,
                            anchoCantidad: null,
                            tipoCaptura: '1'
                        };

                        if (entity.idTipoDatoEntrada == 1) {
                            elemento.largo = 1;
                        }

                        items.push({ label: entity.nombreElemento, value: entity.idElemento, checked: false, entity: entity, elemento: elemento });
                    }

                    index = '' + cont;

                    if (cont <= 9) {
                        index = '0' + cont;
                    }

                    let dato: any = {
                        label: tipoElemento.nombreTipoElemento,
                        items: items,
                        class: 'panel-heading botonizq' + index,
                        index: index,
                        length: 0,
                        checked: false
                    };

                    this.grupoElementos.push(dato);

                    cont++;

                }

            }

            //Agrupar Espacios
            {

                this.grupoEspacios = [];

                cont = 1;

                for (let tipoEspacio of this.datosElemento.listTipoEspacio) {

                    let index: string = '';

                    index = '' + cont;

                    if (cont <= 9) {
                        index = '0' + cont;
                    }

                    let filter = this.espacioForm.listEspacios.filter(row => row.idTipoEspacio == tipoEspacio.idTipoEspacio);

                    let items: any[] = [];

                    for (let entity of filter) {
                        items.push({ label: entity.nombreEspacio, value: entity.idEspacio, checked: false, entity: entity });
                    }

                    let dato: any = {
                        label: tipoEspacio.nombreTipoEspacio,
                        items: items,
                        class: 'panel-heading botonizq01' + index,
                        index: index,
                        entity: tipoEspacio
                    };

                    this.grupoEspacios.push(dato);

                    cont++;

                }

            }

            //Agrupar Prototipos
            {

                this.grupoPrototipos = [];

                cont = 1;

                for (let tipoPrototipo of this.datosElemento.listTipoPrototipo) {

                    let index: string = '';

                    index = '' + cont;

                    if (cont <= 9) {
                        index = '0' + cont;
                    }

                    let dato: any = {
                        label: tipoPrototipo.nombreTipoPrototipo,
                        items: [],
                        class: 'panel-heading botonizq01' + index,
                        index: index,
                        entity: tipoPrototipo
                    };

                    this.grupoPrototipos.push(dato);

                    cont++;

                }
            }

            this.listUnidadMedida = this.datosElemento.listUnidadMedida;

            this.listPersonal = this.datosElemento.listPersonal;

            if (this.grupoElementos != null && this.grupoElementos.length > 0) {
                this.changeMenu(this.grupoElementos[0]);
            }

            if (this.grupoEspacios != null && this.grupoEspacios.length > 0) {
                this.changeMenuEspacio(this.grupoEspacios[0]);
            }

        }

    }

    ///**
    // * 
    // */
    //private initSimuladorForm() {
    //    this.simuladorForm = <EspacioForm>{ nombreEspacio_MensajeError: new FormValidation(null), tab: 0, listaElementos: [] };
    //}

    /**
     * 
     */
    private initEspacioForm() {
        this.espacioForm = <EspacioForm>{ nombreEspacio_MensajeError: new FormValidation(null), tab: 0, listaElementos: [] };
    }

    ///**
    // * 
    // */
    //private initPrototipoForm() {
    //    this.prototipoForm = <PrototipoForm>{
    //        listEspacioSelect: [], nombrePrototipo_MensajeError: new FormValidation(null), prototipoDetalle: <OutputObtenerPrototipoDetalle>{ listDocumento: [], listEspacioxPrototipo: [] }, listPrototipos: [], espacioForm: <EspacioForm>{ nombreEspacio_MensajeError: new FormValidation(null) }, tab: 0
    //    };
    //}

    /**
     * 
     */
    private getClave(): string {

        let clave: string = '';

        switch (this.tipoVivienda) {
            case '0': clave = ''; break;
            case '1': clave = this.datosElemento.listParametro.filter(row => row.idParametro == 1)[0].clave; break;
            case '2': clave = this.datosElemento.listParametro.filter(row => row.idParametro == 2)[0].clave; break;
        }

        return clave;
    }

    /**
     * 
     */
    private getValorClave(): number {

        let valor: number = 0;

        switch (this.tipoVivienda) {
            case '0': valor = 0.0; break;
            case '1': valor = this.datosElemento.listParametro.filter(row => row.idParametro == 1)[0].valor; break;
            case '2': valor = this.datosElemento.listParametro.filter(row => row.idParametro == 2)[0].valor; break;
        }

        return valor;
    }

    /**
     * 
     */
    private getClavePU(): string {

        let clave: string = '';

        switch (this.tipoAsistencia) {
            case '0': clave = this.datosElemento.listParametro.filter(row => row.idParametro == 4)[0].clave; break;
            case '1': clave = this.datosElemento.listParametro.filter(row => row.idParametro == 5)[0].clave; break;
        }

        return clave;
    }

    /**
     * 
     */
    private getValorClavePU(): number {

        let valor: number = 0;

        switch (this.tipoAsistencia) {
            case '0': valor = this.datosElemento.listParametro.filter(row => row.idParametro == 4)[0].valor; break;
            case '1': valor = this.datosElemento.listParametro.filter(row => row.idParametro == 5)[0].valor; break;
        }

        return valor;
    }

    /**
     * 
     */
    private getValorManoObra(): number {

        let valor: number = this.datosElemento.listParametro.filter(row => row.idParametro == 3)[0].valor;

        return valor;
    }

    /**
     * 
     * @param showModal
     */
    public async Calculos(showModal: boolean) {

        this.costoManoObra = [];

        this.precioUnitarioMateriales = [];

        this.costoTotalManoObraXElemento = [];

        this.costoTotalMaterialesXElemento = [];

        let listTablaValores: object[] = [];

        let listElementos: number[] = [];

        this.checked.forEach(row => {
            listTablaValores.push([row.elemento.idElemento, row.elemento.largo, row.elemento.anchoCantidad]);
            listElementos.push(row.elemento.idElemento);
        });

        let costoManoObra: JsonResponse<OutputObtenerCostoManoObra[]> = null;
        let precioUnitarioMateriales: JsonResponse<OutputObtenerCostoPrecioUnitarioMateriales[]> = null;
        let costoTotalManoObraXElemento: JsonResponse<OutputObtenerCostoTotalManoObraXElemento[]> = null;
        let costoTotalMaterialesXElemento: JsonResponse<OutputObtenerCostoTotalMaterialesXElemento[]> = null;

        this.Indirecto = 0;
        this.SubTotal = 0;
        //this.total = 0;

        {
            this.TotalManosObraElemento = 0;
            this.SubTotalManosObraElemento = 0;
            this.IndirectoManosObraElemento = 0;

            let dato: InputObtenerCostoTotalManoObraXElemento = <InputObtenerCostoTotalManoObraXElemento>{
                tablaValores: listTablaValores,
                clave: this.getClave(),
                clavePU: this.getClavePU()
            };

            costoTotalManoObraXElemento = await this.service.ObtenerCostoTotalManoObraXElemento(dato).toPromise();

            if (costoTotalManoObraXElemento != null && costoTotalManoObraXElemento.code == 200 && costoTotalManoObraXElemento.model != null) {

                this.costoTotalManoObraXElemento = costoTotalManoObraXElemento.model;

                for (let row of this.costoTotalManoObraXElemento) {
                    this.TotalManosObraElemento += row.importe;
                }

                let porcentaje: number = 1 + this.getValorManoObra();

                this.SubTotalManosObraElemento = this.TotalManosObraElemento / porcentaje;

                this.IndirectoManosObraElemento = this.TotalManosObraElemento - this.SubTotalManosObraElemento;

            }
        }

        {
            this.TotalMaterialesElemento = 0;

            let dato: InputObtenerCostoTotalMaterialesXElemento = <InputObtenerCostoTotalMaterialesXElemento>{
                tablaValores: listTablaValores,
                clave: this.getClave(),
                clavePU: this.getClavePU()
            };

            costoTotalMaterialesXElemento = await this.service.ObtenerCostoTotalMaterialesXElemento(dato).toPromise();

            if (costoTotalMaterialesXElemento != null && costoTotalMaterialesXElemento.code == 200 && costoTotalMaterialesXElemento.model != null) {

                this.costoTotalMaterialesXElemento = costoTotalMaterialesXElemento.model;

                for (let row of this.costoTotalMaterialesXElemento) {
                    this.TotalMaterialesElemento += row.importe;
                }
            }
        }

        // ** Obtener valores acabados ampliación
        // ** ¿Qué acabados quieres que tenga tu espacio?

        await this.onChangeCostoTotalAmplicacion();

        await this.ExplosionDatosAmpliacion();

        await this.Presupuesto();

        //this.total = this.$Total + this.TotalPresupuestoAmpliacion; 

        this.CostoTotalProyecto = this.$Total + this.TotalPresupuestoAmpliacion;

        //this.onChangeTipoAsistencia();

        //switch (this.tipoVivienda) {
        //    case '0': this.Economico = this.total; break;
        //    case '1': this.Medio = this.total; break;
        //    case '2': this.Alto = this.total; break;
        //}

        if (showModal == true) {
            this.showModalTotales();
        }

    }

    /**
     * 
     */
    public async Presupuesto() {

        this.titulo = 'Presupuesto';

        let listTablaValores: object[] = [];

        this.checked.forEach(row => {
            listTablaValores.push([row.elemento.idElemento, row.elemento.largo, row.elemento.anchoCantidad]);
        });

        this.SubTotal = 0;
        this.Indirecto = 0;
        this.$Total = 0;

        this.costoTotalExcelPresupuestoElemento = [];

        let dato: InputObtenerCostoTotalExcelPresupuestoElemento = <InputObtenerCostoTotalExcelPresupuestoElemento>{
            tablaValores: listTablaValores,
            clave: this.getClave(),
            clavePU: this.getClavePU()
        };

        let respuesta: JsonResponse<OutputObtenerCostoTotalExcelPresupuestoElemento[]> = await this.service.ObtenerCostoTotalExcelPresupuestoElemento(dato).toPromise();

        if (respuesta != null && respuesta.code == 200 && respuesta.model != null) {

            let listaCostoTotalExcelPresupuestoElemento = respuesta.model;

            for (let row of listaCostoTotalExcelPresupuestoElemento) {
                this.$Total += row.subtotal;
            }

            this.$Total = this.$Total / 2;

            let porcentaje: number = 1 + this.getValorClavePU();

            this.SubTotal = this.$Total / porcentaje;

            this.Indirecto = this.$Total - this.SubTotal;

            this.costoTotalExcelPresupuestoElemento = listaCostoTotalExcelPresupuestoElemento;

            //Agrupar nombreTipoElemento
            //{
            //    this.groupCostoTotalExcelPresupuestoElemento = [];

            //    for (let tipoElemento of this.datosElemento.listTipoElementos) {

            //        let filtro = listaCostoTotalExcelPresupuestoElemento.filter(row => row.idTipoElemento == tipoElemento.idTipoElemento);

            //        if (filtro != null && filtro.length > 0) {

            //            let subTotal: number = 0;

            //            for (let row of filtro) {
            //                subTotal += row.subtotal;
            //            }

            //            let costoTotalExcelPresupuestoElemento: CostoTotalExcelPresupuestoElementoDTO = { nombreTipoElemento: tipoElemento.nombreTipoElemento, listCostoTotalExcelPresupuestoElemento: filtro, subtotal: subTotal };

            //            this.groupCostoTotalExcelPresupuestoElemento.push(costoTotalExcelPresupuestoElemento);
            //        }

            //    }

            //    if (this.groupCostoTotalExcelPresupuestoElemento != null && this.groupCostoTotalExcelPresupuestoElemento.length > 0) {

            //        this.costoTotalExcelPresupuestoElemento = [];

            //        for (let row of this.groupCostoTotalExcelPresupuestoElemento) {

            //            let encabezado: OutputObtenerCostoTotalExcelPresupuestoElemento = <OutputObtenerCostoTotalExcelPresupuestoElemento>{ nombreTipoElemento: row.nombreTipoElemento };

            //            this.costoTotalExcelPresupuestoElemento.push(encabezado);

            //            for (let row2 of row.listCostoTotalExcelPresupuestoElemento) {

            //                row2.nombreTipoElemento = null;

            //                this.costoTotalExcelPresupuestoElemento.push(row2);
            //            }

            //            let total: OutputObtenerCostoTotalExcelPresupuestoElemento = <OutputObtenerCostoTotalExcelPresupuestoElemento>{ subtotal: row.subtotal };

            //            this.costoTotalExcelPresupuestoElemento.push(total);

            //        }

            //    }
            //}

        }

        this.showModalTotales();

        this.modalPresupuesto = true;
        this.modalManoObra = false;
        this.modalMateriales = false;
        this.modalPresupuestoAmpliacion = false;
    }

    /**
     * 
     */
    public async ManoObra() {

        await this.Calculos(true);

        this.titulo = 'Mano de obra';
        this.modalPresupuesto = false;
        this.modalManoObra = true;
        this.modalMateriales = false;
        this.modalPresupuestoAmpliacion = false;
    }

    /**
     * 
     */
    public async Materiales() {

        await this.Calculos(true);

        this.titulo = 'Materiales';
        this.modalPresupuesto = false;
        this.modalManoObra = false;
        this.modalMateriales = true;
        this.modalPresupuestoAmpliacion = false;
    }

    /**
    * 
    */
    public async PresupuestoAmpliacion() {

        await this.Calculos(true);

        this.titulo = 'Presupuesto';
        this.modalPresupuesto = false;
        this.modalManoObra = false;
        this.modalMateriales = false;
        this.modalPresupuestoAmpliacion = true;
    }

    /** */
    public async TotalCalculos() {

        await this.Calculos(false);

        this.titulo = null;
        this.modalPresupuesto = false;
        this.modalManoObra = false;
        this.modalMateriales = false;
        this.modalPresupuestoAmpliacion = false;
        this.hideModalTotales();
    }

    /**
     * 
     * @param id
     * @param isChecked
     */
    public onSelectElement(id: number, isChecked: boolean): void {

        this.checkedGrup = [];

        this.checked = [];

        for (var item of this.grupoElementos) {

            let filter = item.items.filter(row => row.checked == true);

            item.length = filter.length;

            this.checked.push(...filter);

            if (filter != null && filter.length > 0) {

                let groups: SelectItemGroups<any, any> = <SelectItemGroups<any, any>>{ label: item.label, items: filter };

                this.checkedGrup.push(groups);

            }
        }

        this.getTipoModalidadObra();

    }

    /**
     * 
     * @param id
     * @param isChecked
     */
    public onSelectEspacio(id: number, isChecked: boolean): void {

        this.checkedGrupEspacio = [];

        this.checkedEspacio = [];

        for (var item of this.grupoEspacios) {

            let filter = item.items.filter(row => row.checked == true);

            item.length = filter.length;

            this.checkedEspacio.push(...filter);

            if (filter != null && filter.length > 0) {

                let groups: SelectItemGroups<any, any> = <SelectItemGroups<any, any>>{ label: item.label, items: filter };

                this.checkedGrupEspacio.push(groups);

            }
        }

    }

    /**
     * 
     */
    //public onChangeTipoAsistencia(): void {

    //    this.ConAsistenciaTecnica = this.total;

    //    this.ConConstructora = this.total;

    //    switch (this.tipoAsistencia) {
    //        case '0': this.CostoTotalProyecto = this.ConAsistenciaTecnica; break;
    //        case '1': this.CostoTotalProyecto = this.ConConstructora; break;
    //    }
    //}

    /**
     * 
     */
    public onChangeCantidad(): void {
        this.setTotales();
    }

    /**
     * 
     * @param entity
     */
    public onChangeM2(entity: ElementoDTO): void {

        entity.m2 = null;

        if ((entity.largo != null && entity.largo > 0) && (entity.anchoCantidad != null && entity.anchoCantidad > 0)) {
            entity.m2 = entity.largo * entity.anchoCantidad;
        }

        this.setTotales();
    }

    /**
     * 
     * @param entity
     */
    public EliminarElemento(entity: SelectItemGroups<any, any>, entity2: SelectItemGroups<OutputObtenerElementos, ElementoDTO>): void {

        console.log('EliminarElemento -->> ')

        const index1 = this.checkedGrup.findIndex(user => user == entity);

        const index2 = this.checkedGrup[index1].items.findIndex(row => row == entity2);

        const index3 = this.checked.findIndex(row => row == entity2);

        this.checkedGrup[index1].items.splice(index2, 1);

        if (this.checkedGrup[index1].items.length == 0) {
            this.checkedGrup.splice(index1, 1);
        }

        this.checked.splice(index3, 1);

        this.grupoElementos.forEach(row => {

            let filter = row.items.filter(row => row.elemento.idElemento == entity2.elemento.idElemento)

            if (filter != null && filter.length > 0) {
                filter[0].checked = false;
            }

            row.length = row.items.filter(row => row.checked == true).length;

        });

        this.setTotales();

    }

    /**
     * 
     */
    private setTotales(): void {
        //this.Economico = 0;
        //this.Medio = 0;
        //this.Alto = 0;
        this.ConAsistenciaTecnica = 0;
        this.ConConstructora = 0;
        this.CostoTotalProyecto = 0;
        //this.tipoVivienda = '';
    }

    /**
     * 
     * @param entity
     */
    public onCheckTipoEspacio(entity: SelectItemGroups<TipoEspacioDTO, any>): void {
        let filter = this.espacioForm.listEspacios.filter(row => row.idTipoEspacio == entity.entity.idTipoEspacio);
        entity.items = filter;
    }

    /**
     * 
     * @param entity
     */
    public onCheckTipoPrototipo(entity: SelectItemGroups<TipoPrototipoDTO, any>): void {

        console.warn('onCheckTipoPrototipo -->> ', entity)

        let filter = this.prototipoForm.listPrototipos.filter(row => row.idTipoPrototipo == entity.entity.idTipoPrototipo);
        entity.items = filter;
    }

    /**
     * 
     */
    public closeAviso(): void {
        this.aviso = false;
    }

    /**
     * 
     */
    public closeModal(): void {
        this.modalTotales = false;
        this.modalDetalleEspacio = false;
    }

    /**
     * 
     */
    public showModalTotales(): void {
        this.modalTotales = true;
    }

    /**
     * 
     */
    public hideModalTotales(): void {
        this.modalTotales = false;
    }


    /**
     * 
     * @param idEspacio
     */
    private async getEspacio(idEspacio: number) {

        let dato: InputObtenerEspacioDetalle = <InputObtenerEspacioDetalle>{ idEspacio: idEspacio };

        let resultado: JsonResponse<OutputObtenerEspacioDetalle> = await this.service.ObtenerEspacioDetalle(dato).toPromise();

        if (resultado != null && resultado.code == 200 && resultado.model != null) {

            if (this.espacioForm.typeView == 'Detalle' || this.espacioForm.typeView == 'Editar') {
                this.espacioForm.idEspacio = resultado.model.espacio.idEspacio;
                this.espacioForm.nombreEspacio = resultado.model.espacio.nombreEspacio;
            }

            this.espacioForm.listaElementos = [];

            if (resultado.model.listElementos != null) {

                this.espacioForm.listaElementos = resultado.model.listElementos;

                for (let row of this.espacioForm.listaElementos) {
                    row.nombreElemento = row.nombreElementoEsp;
                }
            }

        }

        this.showModalDetalleEspacio();

    }

    /**
     * 
     */
    public showModalDetalleEspacio(): void {
        this.modalDetalleEspacio = true;
    }

    /**
     * 
     */
    private getTipoVivienda(): string {

        let tipoVivienda: string = '~~';

        switch (this.tipoVivienda) {
            case '0': tipoVivienda = 'Económico'; break;
            case '1': tipoVivienda = 'Medio'; break;
            case '2': tipoVivienda = 'Alto'; break;
        }

        return tipoVivienda;
    }

    /**
     * 
     */
    private getTipoAsistencia(): string {

        let tipoAsistencia: string = '~~';

        switch (this.tipoAsistencia) {
            case '0': tipoAsistencia = 'Con Asistencia Técnica'; break;
            case '1': tipoAsistencia = ' Con Constructora'; break;
        }

        return tipoAsistencia;
    }

    /**
     * 
     */
    private getTipoModalidadObra(): string {

        this.isAutoproduccion = false;

        let modalidadObra: string = 'ConstruYO Reparaciones Menores';

        this.idModalidadObra = 1;

        let filter = this.checked.filter(row => row.entity.esAutoproduccion == true);

        if (filter != null && filter.length > 0) {
            modalidadObra = 'ConstruYO con Asistencia Técnica o Constructora';
            this.idModalidadObra = 2;
            this.isAutoproduccion = true;
        }

        if (this.ampliacion != null) {
            modalidadObra = 'ConstruYO con Asistencia Técnica o Constructora';
            this.isAutoproduccion = true;
        }

        this.ModalidadObra = modalidadObra;

        return modalidadObra;
    }

    /**
     * 
     */
    public async onChangeTipoVivienda() {

        this.clave = this.getClave();

        await this.TotalCalculos();
    }

    /**
     * 
     */
    public async downloadReporte() {

        let tablaValores: object[] = [];

        let listElementos: number[] = [];

        this.checked.forEach(row => {
            tablaValores.push([row.elemento.idElemento, row.elemento.largo, row.elemento.anchoCantidad]);
            listElementos.push(row.elemento.idElemento);
        });

        let tipoAsistencia: string = this.getTipoAsistencia();

        if (this.isAutoproduccion == false) {
            tipoAsistencia = '~~';
        }

        let datosReporte: InputObtenerReporte = <InputObtenerReporte>{
            listElementos: listElementos,
            tablaValores: tablaValores,
            clave: this.getClave(),
            clavePU: this.getClavePU(),
            modalidadObra: this.getTipoModalidadObra(),
            tipoVivienda: this.getTipoVivienda(),
            tipoAsistencia: tipoAsistencia,
            totalPresupuesto: this.$Total,
            totalManoObra: this.TotalManosObraElemento,
            totalMateriales: this.TotalMaterialesElemento,
            totalPresupuestoAmpliacion: this.TotalPresupuestoAmpliacion,
            totalManoObraAmpliacion: this.TotalManosObraAmpliacion,
            totalMaterialesAmpliacion: this.TotalMaterialesAmpliacion,
            total: this.CostoTotalProyecto,
            costoExcelTotalMaterialesAmpliacion: this.getInputObtenerCostoExcelTotalMaterialesAmpliacion(),
        };

        let resultado: JsonResponse<string> = await this.service.ObtenerReporte(datosReporte).toPromise();

        if (resultado != null && resultado.code == 200 && resultado.model != null) {
            window.open(resultado.model);
        } else {
            console.error('Error en Reporte Elementos-->> ', resultado);
        }

    }

    /**
     * 
     */
    private onChangeAmpliacion(): void {

        for (let row of this.groupsAmpliacion) {
            row.length = 0;
        }

    }

    /**
     * 
     * @param entity
     * @param subMenu
     */
    public async onClickAmpliacion(entity: ItemGroupsAmpliacion<object>, subMenu: any) {

        this.eliminarAmpliacion();

        this.onChangeAmpliacion();

        entity.length = 1;

        this.ampliacion = entity.entity;

        if (subMenu != null) {
            this.largo = subMenu.largo;
            this.ancho = subMenu.ancho;
            this.ampliacion.nombreTipoEspacio = subMenu.descripcion;
            this.urlImage = subMenu.rutaArchivo;
            this.onChaneM2();
        }

        // Set Lista Concepto Integrado Obligatorios

        this.listConceptoIntegradoObligatorios = [];

        let dato: InputObtenerAmpliacionxConceptoIntegrado = <InputObtenerAmpliacionxConceptoIntegrado>{ idAmpliacion: this.ampliacion.idAmpliacion };

        let resultado: JsonResponse<OutputObtenerAmpliacionxConceptoIntegrado> = await this.service.ObtenerAmpliacionxConceptoIntegrado(dato).toPromise();

        if (resultado != null && resultado.code == 200 && resultado.model != null) {

            let listAmpliacionxConceptoIntegrado: AmpliacionxConceptoIntegradoDTO[] = resultado.model.listAmpliacionxConceptoIntegrado;

            let listConceptoIntegrado = this.datosElemento.listConceptoIntegrado;

            this.listConceptoIntegradoObligatorios = this.datosElemento.listConceptoIntegrado.filter(row => row.obligatorio == true);

            let opcionales = this.datosElemento.listConceptoIntegrado.filter(row => row.obligatorio == false);

            let groupAmpliacionxConceptoIntegrado: any[] = [];

            //Agrupar por idConceptoIntegrado

            {
                for (let item of opcionales) {

                    let objeto: any = { listAmpliacionxConceptoIntegrado: [], descripcion: null, iguales: false }

                    let filtro: AmpliacionxConceptoIntegradoDTO[] = listAmpliacionxConceptoIntegrado.filter(row => row.idConceptoIntegrado == item.idConceptoIntegrado);

                    if (filtro != null && filtro.length > 0) {

                        let ampliacionxConceptoIntegrado: AmpliacionxConceptoIntegradoDTO = filtro[0];

                        objeto.listAmpliacionxConceptoIntegrado.push(...filtro);

                        let aux: number = ampliacionxConceptoIntegrado.idElemento * ampliacionxConceptoIntegrado.maximoxAmpliacion;

                        let idElementos: number = 0;

                        let descripcion: string = '';

                        for (let item2 of filtro) {
                            idElementos += item2.idElemento;
                            descripcion += `${item2.nombreElemento} ,`;
                        }

                        if (aux != idElementos) {
                            objeto.descripcion = descripcion;
                        } else {
                            objeto.iguales = true;
                        }

                    }

                    groupAmpliacionxConceptoIntegrado.push(objeto);

                }

            }

            //Set Lista groupAmpliacionxConceptoIntegrado

            // ** Obtener acabados ampliación
            // ** ¿Qué acabados quieres que tenga tu espacio?

            this.groupAmpliacionxConceptoIntegrado = [];

            if (groupAmpliacionxConceptoIntegrado != null && groupAmpliacionxConceptoIntegrado.length > 0) {

                for (let row of groupAmpliacionxConceptoIntegrado) {

                    if (row.iguales == true && row.descripcion == null) {

                        for (let item of row.listAmpliacionxConceptoIntegrado) {

                            let entity: $AmpliacionxConceptoIntegrado = {
                                idAmpliacionxConceptoIntegrado: item.idAmpliacionxConceptoIntegrado,
                                listAmpliacionxConceptoIntegradoDTO: [],
                                descripcionConceptoIntegrado: item.descripcionConceptoIntegrado,
                                idElemento: item.idElemento,
                                nombreElemento: item.nombreElemento,
                                checked: false,
                                costoTotal: 0,
                                descripcion: null,
                                checkedDescripcion: false
                            };

                            this.groupAmpliacionxConceptoIntegrado.push(entity);

                        }

                    } else {

                        let listAmpliacionxConceptoIntegrado: $AmpliacionxConceptoIntegradoDTO[] = [];

                        if (row.listAmpliacionxConceptoIntegrado != null && row.listAmpliacionxConceptoIntegrado.length > 0) {

                            for (let item of row.listAmpliacionxConceptoIntegrado) {

                                let objeto: $AmpliacionxConceptoIntegradoDTO = { idAmpliacionxConceptoIntegrado: item.idAmpliacionxConceptoIntegrado, costoTotal: 0 };

                                listAmpliacionxConceptoIntegrado.push(objeto);
                            }

                            let ampliacionxConceptoIntegrado: AmpliacionxConceptoIntegradoDTO = row.listAmpliacionxConceptoIntegrado[0];

                            let entity: $AmpliacionxConceptoIntegrado = {
                                idAmpliacionxConceptoIntegrado: ampliacionxConceptoIntegrado.idAmpliacionxConceptoIntegrado,
                                listAmpliacionxConceptoIntegradoDTO: listAmpliacionxConceptoIntegrado,
                                descripcionConceptoIntegrado: ampliacionxConceptoIntegrado.descripcionConceptoIntegrado,
                                idElemento: ampliacionxConceptoIntegrado.idElemento,
                                nombreElemento: ampliacionxConceptoIntegrado.nombreElemento,
                                checked: false,
                                costoTotal: 0,
                                descripcion: row.descripcion,
                                checkedDescripcion: false
                            };

                            this.groupAmpliacionxConceptoIntegrado.push(entity);

                        }

                    }

                }

            }

            console.warn('this.groupAmpliacionxConceptoIntegrado  -->> ', this.groupAmpliacionxConceptoIntegrado);

            this.changeTab('pestana4');

            this.getTipoModalidadObra();

        }

    }

    /**
     * 
     */
    public eliminarAmpliacion(): void {
        this.ampliacion = null;
        this.onChangeAmpliacion();
        this.largo = null;
        this.ancho = null;
        this.m2 = null;
        this.tipoPlanta = '1';
        this.costoTotalAmpliacion = 0;
        this.costoTotalConceptoIntegradoObligatorios = 0;
        this.TotalManosObraElemento = 0;
        this.TotalMaterialesElemento = 0;
        this.ConAsistenciaTecnica = 0;
        this.ConConstructora = 0;
        this.CostoTotalProyecto = 0;
        this.getTipoModalidadObra();
    }

    /**
     * 
     */
    /* private Calculos_CostoTotalAmpliacion(): void {
 
         this.costoTotalAmpliacion = this.costoTotalConceptoIntegradoObligatorios;
 
         if (this.groupAmpliacionxConceptoIntegrado != null && this.groupAmpliacionxConceptoIntegrado.length > 0) {
 
             for (let row of this.groupAmpliacionxConceptoIntegrado) {
 
                 if (row.checked == true) {
 
                     this.costoTotalAmpliacion += row.costoTotal;
                 }
 
             }
 
         }
 
         console.warn('this.costoTotalAmpliacion -->> ', this.costoTotalAmpliacion);
 
     }*/

    /**
     * 
     */
    public async checkAll() {

        if (this.groupAmpliacionxConceptoIntegrado != null && this.groupAmpliacionxConceptoIntegrado.length > 0) {

            for (let item of this.groupAmpliacionxConceptoIntegrado) {
                item.checked = this.checkedAll;
            }

        }

        this.TotalCalculos();

    }

    /**
     * 
     */
    public async checkElementoAmpliacion() {
        this.TotalCalculos();
    }

    /**
     * 
     */
    public async onChaneM2() {

        this.costoTotalConceptoIntegradoObligatorios = 0;

        this.m2 = 0;

        if ((this.largo != null && this.largo > 0) && (this.ancho != null && this.ancho > 0)) {

            this.m2 = this.largo * this.ancho;

            await this.TotalCalculos();
        }

    }

    /**
     * Obtener valores acabados ampliación
     * ¿Qué acabados quieres que tenga tu espacio?
     */
    private async onChangeCostoTotalAmplicacion() {

        await this.ObtenerCostoTotalExcelAmpliacion();

        let filter = this.costoTotalExcelAmpliacion.filter(item => item.obligatorio == true);

        this.costoTotalConceptoIntegradoObligatorios = 0;

        for (let row of filter) {
            this.costoTotalConceptoIntegradoObligatorios += row.costoTotal;
        }

        for (let row of this.groupAmpliacionxConceptoIntegrado) {

            if (row.listAmpliacionxConceptoIntegradoDTO.length == 0) {

                let filter = this.costoTotalExcelAmpliacion.filter(item => item.idAmpliacionxConceptoIntegrado == row.idAmpliacionxConceptoIntegrado);

                if (filter != null && filter.length > 0) {
                    row.costoTotal = filter[0].costoTotal;
                }

            } else {

                let costoTotal: number = 0;

                for (let item0 of row.listAmpliacionxConceptoIntegradoDTO) {

                    let filter = this.costoTotalExcelAmpliacion.filter(item => item.idAmpliacionxConceptoIntegrado == item0.idAmpliacionxConceptoIntegrado);

                    if (filter != null && filter.length > 0) {
                        item0.costoTotal = filter[0].costoTotal;

                        costoTotal += item0.costoTotal;
                    }
                }

                row.costoTotal = costoTotal;

            }

        }

        //this.Calculos_CostoTotalAmpliacion();

    }

    /**
     * 
     * @param entity
     */
    public detalleDescripcion(entity: $AmpliacionxConceptoIntegrado): void {
        entity.checkedDescripcion = !entity.checkedDescripcion;
    }


    /**
     * 
     */
    private getInputObtenerCostoExcelTotalMaterialesAmpliacion(): any {

        let tablaAmpliacionxConceptoIntegrado: number[] = [];

        let noSelect = this.groupAmpliacionxConceptoIntegrado.filter(row => row.checked == false);

        if (noSelect != null && noSelect.length > 0) {

            for (let row of noSelect) {

                if (row.listAmpliacionxConceptoIntegradoDTO != null && row.listAmpliacionxConceptoIntegradoDTO.length > 0) {

                    for (let row2 of row.listAmpliacionxConceptoIntegradoDTO) {
                        tablaAmpliacionxConceptoIntegrado.push(row2.idAmpliacionxConceptoIntegrado)
                    }

                } else {
                    tablaAmpliacionxConceptoIntegrado.push(row.idAmpliacionxConceptoIntegrado)
                }

            }

        }

        let dato: InputObtenerCostoExcelTotalMaterialesAmpliacion = null;

        if (this.ampliacion != null && this.ampliacion.idAmpliacion != null) {

            dato = <InputObtenerCostoExcelTotalMaterialesAmpliacion>{
                idAmpliacion: this.ampliacion.idAmpliacion,
                largo: this.largo,
                ancho: this.ancho,
                idAltura: 1,
                idPiso: Number(this.tipoPlanta),
                tablaAmpliacionxConceptoIntegrado: tablaAmpliacionxConceptoIntegrado,
                clave: this.getClave(),
                clavePU: this.getClavePU()
            };

        }

        return dato;

    }

    /**
     * 
     * @param showModal
     */
    public async ExplosionDatosAmpliacion() {

        // CostoExcelTotalManoObraAmpliacion

        {
            this.costoExcelTotalManoObraAmpliacion = [];
            this.TotalManosObraAmpliacion = 0;
            this.SubTotalManosObraAmpliacion = 0;
            this.IndirectoManosObraAmpliacion = 0;

            if (this.ampliacion != null && this.ampliacion.idAmpliacion != null) {

                let dato: InputObtenerCostoExcelTotalMaterialesAmpliacion = this.getInputObtenerCostoExcelTotalMaterialesAmpliacion();

                let respuesta: JsonResponse<OutputObtenerCostoExcelTotalManoObraAmpliacion> = await this.service.ObtenerCostoExcelTotalManoObraAmpliacion(dato).toPromise();

                if (respuesta != null && respuesta.code == 200 && respuesta.model != null) {

                    this.costoExcelTotalManoObraAmpliacion = respuesta.model.listCostoExcelTotalManoObraAmpliacion;

                    for (let row of this.costoExcelTotalManoObraAmpliacion) {
                        this.TotalManosObraAmpliacion += row.importe;
                    }

                    let porcentaje: number = 1 + this.getValorManoObra();

                    this.SubTotalManosObraAmpliacion = this.TotalManosObraAmpliacion / porcentaje;

                    this.IndirectoManosObraAmpliacion = this.TotalManosObraAmpliacion - this.SubTotalManosObraAmpliacion;


                }

            }

        }

        // ObtenerCostoExcelTotalMaterialesAmpliacion

        {
            this.costoExcelTotalMaterialesAmpliacion = [];

            this.TotalMaterialesAmpliacion = 0;

            if (this.ampliacion != null && this.ampliacion.idAmpliacion != null) {

                let dato: InputObtenerCostoExcelTotalMaterialesAmpliacion = this.getInputObtenerCostoExcelTotalMaterialesAmpliacion();

                let respuesta: JsonResponse<OutputObtenerCostoExcelTotalMaterialesAmpliacion> = await this.service.ObtenerCostoExcelTotalMaterialesAmpliacion(dato).toPromise();

                if (respuesta != null && respuesta.code == 200 && respuesta.model != null) {

                    this.costoExcelTotalMaterialesAmpliacion = respuesta.model.listCostoExcelTotalMaterialesAmpliacion;

                    for (let row of this.costoExcelTotalMaterialesAmpliacion) {
                        this.TotalMaterialesAmpliacion += row.importe;
                    }

                }

            }

        }

        // ObtenerCostoTotalExcelPresupuestoAmpliacion

        {
            this.costoTotalExcelPresupuestoAmpliacion = [];

            this.TotalPresupuestoAmpliacion = 0;

            this.SubTotalAmpliacion = 0;

            this.IndirectoAmpliacion = 0;

            if (this.ampliacion != null && this.ampliacion.idAmpliacion != null) {

                let dato: InputObtenerCostoTotalExcelPresupuestoAmpliacion = this.getInputObtenerCostoExcelTotalMaterialesAmpliacion();

                let respuesta: JsonResponse<OutputObtenerCostoTotalExcelPresupuestoAmpliacion> = await this.service.ObtenerCostoTotalExcelPresupuestoAmpliacion(dato).toPromise();

                if (respuesta != null && respuesta.code == 200 && respuesta.model != null) {

                    let listaCostoTotalExcelPresupuestoAmpliacion = respuesta.model.listCostoExcelTotalManoObraAmpliacion;

                    for (let row of listaCostoTotalExcelPresupuestoAmpliacion) {
                        this.TotalPresupuestoAmpliacion += row.subtotal;
                    }

                    this.TotalPresupuestoAmpliacion = this.TotalPresupuestoAmpliacion / 2;

                    let porcentaje: number = 1 + this.getValorClavePU();

                    this.SubTotalAmpliacion = this.TotalPresupuestoAmpliacion / porcentaje;

                    this.IndirectoAmpliacion = this.TotalPresupuestoAmpliacion - this.SubTotalAmpliacion;

                    this.costoTotalExcelPresupuestoAmpliacion = listaCostoTotalExcelPresupuestoAmpliacion;
                    
                    // Agrupar [ Nombre tipo elemento ]

                    //{
                    //    this.groupCostoTotalExcelPresupuestoElemento = [];

                    //    for (let tipoElemento of this.datosElemento.listTipoElementos) {

                    //        let filtro = listaCostoTotalExcelPresupuestoAmpliacion.filter(row => row.idTipoElemento == tipoElemento.idTipoElemento);

                    //        if (filtro != null && filtro.length > 0) {

                    //            let subTotal: number = 0;

                    //            for (let row of filtro) {
                    //                subTotal += row.subtotal;
                    //            }

                    //            let costoTotalExcelPresupuestoElemento: CostoTotalExcelPresupuestoElementoDTO = { nombreTipoElemento: tipoElemento.nombreTipoElemento, listCostoTotalExcelPresupuestoElemento: filtro, subtotal: subTotal };

                    //            this.groupCostoTotalExcelPresupuestoElemento.push(costoTotalExcelPresupuestoElemento);
                    //        }

                    //    }

                    //    if (this.groupCostoTotalExcelPresupuestoElemento != null && this.groupCostoTotalExcelPresupuestoElemento.length > 0) {

                    //        this.costoTotalExcelPresupuestoAmpliacion = [];

                    //        for (let row of this.groupCostoTotalExcelPresupuestoElemento) {

                    //            let encabezado: OutputObtenerCostoTotalExcelPresupuestoElemento = <OutputObtenerCostoTotalExcelPresupuestoElemento>{ nombreTipoElemento: row.nombreTipoElemento };

                    //            this.costoTotalExcelPresupuestoAmpliacion.push(encabezado);

                    //            for (let row2 of row.listCostoTotalExcelPresupuestoElemento) {

                    //                row2.nombreTipoElemento = null;

                    //                this.costoTotalExcelPresupuestoAmpliacion.push(row2);
                    //            }

                    //            let total: OutputObtenerCostoTotalExcelPresupuestoElemento = <OutputObtenerCostoTotalExcelPresupuestoElemento>{ subtotal: row.subtotal };

                    //            this.costoTotalExcelPresupuestoAmpliacion.push(total);

                    //        }

                    //    }


                    //}


                }

            }

        }

    }


    /** para que se vaya al html bookmark del calculo arriba **/
    scrollToElement($element): void {
        console.log($element);
        $element.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
    }

    /**
     * 
     * @param entity
     */
    public onChangeTipoCaptura(entity: ElementoDTO): void {

        if (entity.tipoCaptura == '1') {
            entity.largo = null;
            entity.anchoCantidad = null;
            entity.m2 = null;
        }

        if (entity.tipoCaptura == '2') {
            entity.largo = 1;
            entity.anchoCantidad = null;
            entity.m2 = null;
        }

    }

    /**
     * 
     * @param nombreElemento
     * @param descripcionAmplia
     */
    public detalleModalElemento(nombreElemento: string, descripcionAmplia: string) {
        this.descripcionAmplia = descripcionAmplia;
        this.nombreElemento = nombreElemento;
    }

    /**
     * 
     */
    public verPlano() {

        this.tituloModal = `Plano - ${this.ampliacion.nombreTipoEspacio}`;

        this.listDocument = [];

        let documento: DocumentosXAmpliacionDTO = <DocumentosXAmpliacionDTO>{ rutaArchivo: this.urlImage };

        this.listDocument.push(documento);

        //if (this.listDocumentosXAmpliacion != null) {

        //    let filter = this.listDocumentosXAmpliacion.filter(row => row.idCatalogoDocumento == 3 && row.idAmpliacion == this.ampliacion.idAmpliacion);

        //    if (filter != null && filter.length > 0) {
        //        this.listDocument.push(...filter);
        //    }

        //}
    }

    /**
     * 
     */
    public queIncluye() {

        this.tituloModal = `¿Qué incluye? - ${this.ampliacion.nombreTipoEspacio}`;

        this.listDocument = [];

        if (this.listDocumentosXAmpliacion != null) {

            let filter = this.listDocumentosXAmpliacion.filter(row => row.idCatalogoDocumento == 4 && row.idAmpliacion == this.ampliacion.idAmpliacion);

            if (filter != null && filter.length > 0) {
                this.listDocument.push(...filter);
            }

        }
    }

    /**
     * 
     * @param label
     * @param rutaArchivo
     */
    public ampliarImagen(label: string, rutaArchivo: string) {

        this.tituloModal = `${label}`;

        this.listDocument = [];

        let documentosXAmpliacion: DocumentosXAmpliacionDTO = <DocumentosXAmpliacionDTO>{ rutaArchivo: rutaArchivo };

        this.listDocument.push(documentosXAmpliacion);
    }

}